"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/themes/index.ts
var themes_exports = {};
__export(themes_exports, {
  CdoTheme: () => code_default
});
module.exports = __toCommonJS(themes_exports);

// src/themes/code.org/index.ts
var import_material = require("@mui/material");

// src/themes/code.org/constants/fonts.ts
var BARLOW_FONT = "Barlow Semi Condensed Semibold";
var FIGTREE_FONT = "Figtree";
var NOTO_FONT = "Noto Sans, Noto Sans Math, Noto Sans Arabic, Noto Sans Armenian, Noto Sans Bengali, Noto Sans SC, Noto Sans TC, Noto Sans Devanagari, Noto Sans Georgian, Noto Sans Hebrew, Noto Sans JP, Noto Sans Kannada, Noto Sans Khmer, Noto Sans KR, Noto Sans Myanmar, Noto Sans Sinhala, Noto Sans Tamil, Noto Sans Telugu, Noto Sans Thai, Noto Sans Thaana";
var createFontStack = (font, fallback) => {
  return [font, fallback, "sans-serif"].join(", ");
};

// src/themes/code.org/styleOverrides/breadcrumbs.ts
var BREADCRUMBS_OVERRIDES = {
  styleOverrides: {
    root: ({ theme: theme2, ownerState }) => {
      const size = ownerState.size || "m";
      const label2Styles = theme2.typography.label2;
      const label1Styles = theme2.typography.label1;
      const label3Styles = theme2.typography.label3;
      const label4Styles = theme2.typography.label4;
      const sizeStyles = {
        xs: label4Styles,
        s: label3Styles,
        m: label2Styles,
        l: label1Styles
      };
      return {
        display: "inline-flex",
        alignItems: "center",
        fontFeatureSettings: "'liga' off, 'clig' off",
        // Use typography styles based on size
        ...sizeStyles[size],
        // Style the links within breadcrumbs
        // MUI uses Link components for breadcrumb items
        "& .MuiLink-root, & .MuiBreadcrumbs-li > a": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "var(--text-neutral-primary)",
          textDecoration: "none",
          borderRadius: "4px",
          margin: 0,
          ...sizeStyles[size],
          lineHeight: "inherit",
          gap: "0.375rem",
          // Remove default Link underline
          "&:hover, &:active, &:visited": {
            textDecoration: "none"
          },
          // Current/active breadcrumb (last item)
          '&[aria-current="page"]': {
            color: "var(--text-brand-teal-primary)",
            cursor: "default",
            pointerEvents: "none"
          },
          // Focus styles
          "&:focus-visible": {
            color: "var(--text-neutral-primary)",
            outline: "2px solid var(--borders-brand-teal-primary)",
            outlineOffset: "2px"
          }
        },
        // Hover, active, visited states for non-last breadcrumbs
        "& .MuiBreadcrumbs-li:not(:last-child) .MuiLink-root:hover, & .MuiBreadcrumbs-li:not(:last-child) > a:hover, & .MuiBreadcrumbs-li:not(:last-child) .MuiLink-root:active, & .MuiBreadcrumbs-li:not(:last-child) > a:active, & .MuiBreadcrumbs-li:not(:last-child) .MuiLink-root:visited, & .MuiBreadcrumbs-li:not(:last-child) > a:visited": {
          color: "var(--text-neutral-secondary)"
        },
        // Last breadcrumb link styling (when not using aria-current)
        "& .MuiBreadcrumbs-li:last-child .MuiLink-root, & .MuiBreadcrumbs-li:last-child > a": {
          color: "var(--text-brand-teal-primary)",
          cursor: "default",
          pointerEvents: "none"
        },
        // Last breadcrumb Typography styling (current page)
        // Need higher specificity to override Typography default color
        "& .MuiBreadcrumbs-li:last-child .MuiTypography-root": {
          color: "var(--text-brand-teal-primary) !important",
          cursor: "default"
        },
        // Also target Typography directly within breadcrumbs li:last-child
        "& .MuiBreadcrumbs-li:last-child > .MuiTypography-root": {
          color: "var(--text-brand-teal-primary) !important",
          display: "inline-flex",
          alignItems: "center",
          gap: "0.25rem"
          // Add gap between icon and text
        }
      };
    },
    ol: {
      display: "inline-flex",
      alignItems: "center",
      margin: 0,
      padding: 0,
      listStyle: "none"
    },
    li: {
      display: "inline-flex",
      alignItems: "center",
      margin: 0,
      padding: 0
    },
    separator: ({ ownerState }) => {
      const size = ownerState.size || "m";
      const separatorStyles = {
        xs: {
          padding: "4px 6px",
          fontSize: "10px",
          width: "13px",
          lineHeight: 1.25
        },
        s: {
          padding: "5px 6px",
          fontSize: "11px",
          width: "14px",
          lineHeight: 1.25
        },
        m: {
          padding: "5px 6px",
          fontSize: "12px",
          width: "15px",
          lineHeight: 1.25
        },
        l: {
          padding: "6px",
          fontSize: "13px",
          width: "16px",
          lineHeight: 1.25
        }
      };
      const sizeConfig = separatorStyles[size];
      return {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "var(--text-neutral-tertiary)",
        marginLeft: 0,
        marginRight: 0,
        padding: sizeConfig.padding,
        fontSize: sizeConfig.fontSize,
        lineHeight: sizeConfig.lineHeight,
        // Target child icon elements (FontAwesomeV6Icon renders as i or svg)
        // The width and fontSize should be applied to the icon element itself,
        // matching the SCSS where the i element has these properties directly
        "& > i, & > svg, & i, & svg": {
          fontSize: sizeConfig.fontSize,
          width: sizeConfig.width,
          height: "auto",
          lineHeight: sizeConfig.lineHeight,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0
          // Prevent shrinking
        }
      };
    }
  }
};

// src/themes/code.org/styleOverrides/button.tsx
var SIZE_SPECS = {
  xs: {
    padding: "0.125rem 0.5rem",
    gap: "0.25rem",
    fontSize: "0.75rem",
    // button-four-text
    lineHeight: 1.64,
    // button-four-text
    iconSize: "0.8125rem",
    iconWidth: "1rem",
    iconOnlyPadding: "0.25rem",
    iconOnlyMinWidth: "1.5rem"
  },
  s: {
    padding: "0.3125rem 1rem",
    gap: "0.5rem",
    fontSize: "0.875rem",
    // button-three-text
    lineHeight: 1.54,
    // button-three-text
    iconSize: "0.875rem",
    iconWidth: "1.125rem",
    iconOnlyPadding: "0.4375rem",
    iconOnlyMinWidth: "2rem"
  },
  m: {
    padding: "0.5rem 1rem",
    gap: "0.5rem",
    fontSize: "1rem",
    // button-two-text
    lineHeight: 1.48,
    // button-two-text
    iconSize: "1rem",
    iconWidth: "1.25rem",
    iconOnlyPadding: "0.625rem",
    iconOnlyMinWidth: "2.5rem"
  },
  l: {
    padding: "0.625rem 1rem",
    gap: "0.5rem",
    fontSize: "1.25rem",
    // button-one-text
    lineHeight: 1.4,
    // button-one-text
    iconSize: "1.1875rem",
    iconWidth: "1.5rem",
    iconOnlyPadding: "0.75rem",
    iconOnlyMinWidth: "3rem"
  }
};
var BUTTON_OVERRIDES = {
  defaultProps: {
    disableRipple: true
  },
  // Add variants for custom sizes
  variants: [
    // Extra small size
    {
      props: { size: "extraSmall" },
      style: () => {
        const specs = SIZE_SPECS.xs;
        return {
          padding: specs.padding,
          gap: specs.gap,
          minHeight: "auto",
          fontSize: specs.fontSize,
          lineHeight: specs.lineHeight,
          "& .MuiButton-startIcon, & .MuiButton-endIcon": {
            fontSize: specs.iconSize,
            width: specs.iconWidth,
            "& i": {
              fontSize: specs.iconSize,
              width: specs.iconWidth
            }
          },
          '&[data-icon-only="true"]': {
            padding: specs.iconOnlyPadding,
            minWidth: specs.iconOnlyMinWidth
          }
        };
      }
    },
    // Small size
    {
      props: { size: "small" },
      style: () => {
        const specs = SIZE_SPECS.s;
        return {
          padding: specs.padding,
          gap: specs.gap,
          minHeight: "auto",
          fontSize: specs.fontSize,
          lineHeight: specs.lineHeight,
          "& .MuiButton-startIcon, & .MuiButton-endIcon": {
            fontSize: specs.iconSize,
            width: specs.iconWidth,
            "& i": {
              fontSize: specs.iconSize,
              width: specs.iconWidth
            }
          },
          '&[data-icon-only="true"]': {
            padding: specs.iconOnlyPadding,
            minWidth: specs.iconOnlyMinWidth
          }
        };
      }
    },
    // Medium size (default)
    {
      props: { size: "medium" },
      style: () => {
        const specs = SIZE_SPECS.m;
        return {
          padding: specs.padding,
          gap: specs.gap,
          minHeight: "auto",
          fontSize: specs.fontSize,
          lineHeight: specs.lineHeight,
          "& .MuiButton-startIcon, & .MuiButton-endIcon": {
            fontSize: specs.iconSize,
            width: specs.iconWidth,
            "& i": {
              fontSize: specs.iconSize,
              width: specs.iconWidth
            }
          },
          '&[data-icon-only="true"]': {
            padding: specs.iconOnlyPadding,
            minWidth: specs.iconOnlyMinWidth
          }
        };
      }
    },
    // Large size
    {
      props: { size: "large" },
      style: () => {
        const specs = SIZE_SPECS.l;
        return {
          padding: specs.padding,
          gap: specs.gap,
          minHeight: "auto",
          fontSize: specs.fontSize,
          lineHeight: specs.lineHeight,
          "& .MuiButton-startIcon, & .MuiButton-endIcon": {
            fontSize: specs.iconSize,
            width: specs.iconWidth,
            "& i": {
              fontSize: specs.iconSize,
              width: specs.iconWidth
            }
          },
          '&[data-icon-only="true"]': {
            padding: specs.iconOnlyPadding,
            minWidth: specs.iconOnlyMinWidth
          }
        };
      }
    },
    // Contained (primary) variant × color combinations
    {
      props: { variant: "contained", color: "primary" },
      style: {
        backgroundColor: "var(--background-brand-purple-primary)",
        color: "var(--text-neutral-white-fixed)",
        '&:hover, &.force-hover, &[data-force-hover="true"]': {
          backgroundColor: "var(--background-brand-purple-strong)",
          color: "var(--text-neutral-white-fixed)"
        },
        "&:focus, a&:focus": {
          color: "var(--text-neutral-white-fixed)"
        },
        "&:active, a&:active": {
          color: "var(--text-neutral-white-fixed)"
        },
        "&.Mui-disabled": {
          backgroundColor: "var(--background-neutral-disabled)",
          color: "var(--text-neutral-disabled-inverse)"
        }
      }
    },
    {
      props: { variant: "contained", color: "secondary" },
      style: {
        backgroundColor: "var(--background-neutral-primary-inverse)",
        color: "var(--text-neutral-inverse)",
        '&:hover, &.force-hover, &[data-force-hover="true"]': {
          backgroundColor: "var(--background-neutral-octonary)",
          color: "var(--text-neutral-inverse)"
        },
        "&:focus, a&:focus": {
          color: "var(--text-neutral-inverse)"
        },
        "&:active, a&:active": {
          color: "var(--text-neutral-inverse)"
        },
        "&.Mui-disabled": {
          backgroundColor: "var(--background-neutral-disabled)",
          color: "var(--text-neutral-disabled-inverse)"
        }
      }
    },
    {
      props: { variant: "contained", color: "white" },
      style: {
        backgroundColor: "var(--background-neutral-white-fixed)",
        color: "var(--text-neutral-primary)",
        '&:hover, &.force-hover, &[data-force-hover="true"]': {
          backgroundColor: "var(--background-neutral-quaternary)",
          color: "var(--text-neutral-primary)"
        },
        "&:focus, a&:focus": {
          color: "var(--text-neutral-primary)"
        },
        "&:active, a&:active": {
          color: "var(--text-neutral-primary)"
        },
        "&.Mui-disabled": {
          backgroundColor: "var(--background-neutral-octonary)",
          color: "var(--text-neutral-primary)"
        }
      }
    },
    {
      props: { variant: "contained", color: "error" },
      style: {
        backgroundColor: "var(--background-error-primary)",
        color: "var(--text-neutral-white-fixed)",
        '&:hover, &.force-hover, &[data-force-hover="true"]': {
          backgroundColor: "var(--background-error-strong)",
          color: "var(--text-neutral-white-fixed)"
        },
        "&:focus, a&:focus": {
          color: "var(--text-neutral-white-fixed)"
        },
        "&:active, a&:active": {
          color: "var(--text-neutral-white-fixed)"
        },
        "&.Mui-disabled": {
          backgroundColor: "var(--background-neutral-disabled)",
          color: "var(--text-neutral-disabled-inverse)"
        }
      }
    },
    // Outlined (secondary) variant × color combinations
    {
      props: { variant: "outlined", color: "primary" },
      style: {
        border: "1px solid var(--borders-brand-purple-primary)",
        color: "var(--text-brand-purple-primary)",
        '&:hover, &.force-hover, &[data-force-hover="true"]': {
          backgroundColor: "var(--background-brand-purple-hover)",
          border: "1px solid var(--borders-brand-purple-primary)",
          color: "var(--text-brand-purple-primary)"
        },
        "&:focus, a&:focus": {
          color: "var(--text-brand-purple-primary)"
        },
        "&:active, a&:active": {
          border: "1px solid var(--borders-brand-purple-primary)",
          color: "var(--text-brand-purple-primary)"
        },
        "&.Mui-disabled": {
          borderColor: "var(--borders-neutral-disabled) !important",
          color: "var(--text-neutral-disabled)",
          backgroundColor: "var(--background-neutral-primary)"
        }
      }
    },
    {
      props: { variant: "outlined", color: "secondary" },
      style: {
        border: "1px solid var(--borders-neutral-solid)",
        backgroundColor: "var(--background-neutral-primary)",
        color: "var(--text-neutral-primary)",
        '&:hover, &.force-hover, &[data-force-hover="true"]': {
          backgroundColor: "var(--background-neutral-tertiary)",
          border: "1px solid var(--borders-neutral-solid)",
          color: "var(--text-neutral-primary)"
        },
        "&:focus, a&:focus": {
          color: "var(--text-neutral-primary)"
        },
        "&:active, a&:active": {
          border: "1px solid var(--borders-neutral-solid)",
          color: "var(--text-neutral-primary)"
        },
        "&.Mui-disabled": {
          borderColor: "var(--borders-neutral-disabled) !important",
          color: "var(--text-neutral-disabled)",
          backgroundColor: "var(--background-neutral-primary)"
        }
      }
    },
    {
      props: { variant: "outlined", color: "tertiary" },
      style: {
        border: "1px solid var(--borders-neutral-strong)",
        backgroundColor: "var(--background-neutral-primary)",
        color: "var(--text-neutral-primary)",
        '&:hover, &.force-hover, &[data-force-hover="true"]': {
          backgroundColor: "var(--background-neutral-tertiary)",
          border: "1px solid var(--borders-neutral-strong)",
          color: "var(--text-neutral-primary)"
        },
        "&:focus, a&:focus": {
          color: "var(--text-neutral-primary)"
        },
        "&:active, a&:active": {
          border: "1px solid var(--borders-neutral-strong)",
          color: "var(--text-neutral-primary)"
        },
        "&.Mui-disabled": {
          borderColor: "var(--borders-neutral-disabled) !important",
          color: "var(--text-neutral-disabled)",
          backgroundColor: "var(--background-neutral-primary)"
        }
      }
    },
    {
      props: { variant: "outlined", color: "white" },
      style: {
        border: "1px solid var(--neutral-base-white)",
        backgroundColor: "var(--neutral-base-black)",
        color: "var(--neutral-base-white)",
        '&:hover, &.force-hover, &[data-force-hover="true"]': {
          backgroundColor: "var(--neutral-gray-80)",
          border: "1px solid var(--neutral-base-white)",
          color: "var(--neutral-base-white)"
        },
        "&:focus, a&:focus": {
          color: "var(--neutral-base-white)"
        },
        "&:active, a&:active": {
          border: "1px solid var(--neutral-base-white)",
          color: "var(--neutral-base-white)"
        },
        "&.Mui-disabled": {
          borderColor: "var(--neutral-gray-80) !important",
          color: "var(--neutral-gray-80)",
          backgroundColor: "unset"
        }
      }
    },
    {
      props: { variant: "outlined", color: "error" },
      style: {
        backgroundColor: "var(--background-neutral-primary)",
        border: "1px solid var(--borders-error-primary)",
        color: "var(--text-error-primary)",
        '&:hover, &.force-hover, &[data-force-hover="true"]': {
          backgroundColor: "var(--background-error-light)",
          border: "1px solid var(--borders-error-primary)",
          color: "var(--text-error-primary)"
        },
        "&:focus, a&:focus": {
          color: "var(--text-error-primary)"
        },
        "&:active, a&:active": {
          border: "1px solid var(--borders-error-primary)",
          color: "var(--text-error-primary)"
        },
        "&.Mui-disabled": {
          borderColor: "var(--borders-neutral-disabled) !important",
          color: "var(--text-neutral-disabled)",
          backgroundColor: "var(--background-neutral-primary)"
        }
      }
    },
    // Text (tertiary) variant × color combinations
    {
      props: { variant: "text", color: "primary" },
      style: {
        color: "var(--text-brand-purple-primary)",
        '&:hover, &.force-hover, &[data-force-hover="true"]': {
          backgroundColor: "var(--background-brand-purple-hover)",
          color: "var(--text-brand-purple-primary)"
        },
        "&:focus, a&:focus": {
          color: "var(--text-brand-purple-primary)"
        },
        "&:active, a&:active": {
          backgroundColor: "var(--background-brand-purple-hover)",
          color: "var(--text-brand-purple-secondary)"
        },
        "&.Mui-disabled": {
          color: "var(--text-neutral-disabled)",
          backgroundColor: "unset"
        }
      }
    },
    {
      props: { variant: "text", color: "secondary" },
      style: {
        color: "var(--text-neutral-primary)",
        '&:hover, &.force-hover, &[data-force-hover="true"]': {
          backgroundColor: "var(--background-neutral-quaternary)",
          color: "var(--text-neutral-primary)"
        },
        "&:focus, a&:focus": {
          color: "var(--text-neutral-primary)"
        },
        "&:active, a&:active": {
          backgroundColor: "var(--background-neutral-quaternary)",
          color: "var(--text-neutral-tertiary)"
        },
        "&.Mui-disabled": {
          color: "var(--text-neutral-disabled)",
          backgroundColor: "unset"
        }
      }
    },
    {
      props: { variant: "text", color: "tertiary" },
      style: {
        color: "var(--text-neutral-quaternary)",
        '&:hover, &.force-hover, &[data-force-hover="true"]': {
          backgroundColor: "var(--background-neutral-quaternary)",
          color: "var(--text-neutral-quaternary)"
        },
        "&:focus, a&:focus": {
          color: "var(--text-neutral-quaternary)"
        },
        "&:active, a&:active": {
          backgroundColor: "var(--background-neutral-quaternary)",
          color: "var(--text-neutral-tertiary)"
        },
        "&.Mui-disabled": {
          color: "var(--text-neutral-disabled)",
          backgroundColor: "unset"
        }
      }
    },
    {
      props: { variant: "text", color: "white" },
      style: {
        color: "var(--neutral-base-white)",
        '&:hover, &.force-hover, &[data-force-hover="true"]': {
          backgroundColor: "var(--neutral-white-alpha-30)",
          color: "var(--neutral-base-white)"
        },
        "&:focus, a&:focus": {
          color: "var(--text-neutral-inverse)"
        },
        "&:active, a&:active": {
          backgroundColor: "var(--neutral-white-alpha-30)",
          color: "var(--neutral-gray-20)"
        },
        "&.Mui-disabled": {
          color: "var(--text-neutral-tertiary)",
          backgroundColor: "unset"
        }
      }
    },
    {
      props: { variant: "text", color: "error" },
      style: {
        color: "var(--text-error-primary)",
        '&:hover, &.force-hover, &[data-force-hover="true"]': {
          backgroundColor: "var(--background-error-light)",
          color: "var(--text-error-primary)"
        },
        "&:focus, a&:focus": {
          color: "var(--text-error-primary)"
        },
        "&:active, a&:active": {
          backgroundColor: "var(--background-error-light)",
          color: "var(--text-error-secondary)"
        },
        "&.Mui-disabled": {
          color: "var(--text-neutral-disabled)",
          backgroundColor: "unset"
        }
      }
    }
  ],
  styleOverrides: {
    root: () => {
      const baseStyles = {
        borderRadius: "0.25rem",
        boxSizing: "border-box",
        margin: 0,
        border: "1px solid transparent",
        textDecoration: "none",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        fontWeight: 600,
        // Button text is always bold
        textTransform: "none",
        // Remove MUI's default uppercase
        minHeight: "auto",
        // Remove MUI's default minHeight
        lineHeight: "normal",
        // Use normal line height
        boxShadow: "none",
        // Remove MUI's default shadow
        // Override global link styles when button is rendered as <a>
        // Using more specific selectors to override global a:hover, a:focus, a:active
        "&:hover, a&:hover": {
          boxShadow: "none",
          // Remove shadow on hover
          textDecoration: "none"
          // Override global a:hover styles via specificity
        },
        "&:focus, a&:focus": {
          boxShadow: "none",
          // Remove shadow on focus
          textDecoration: "none",
          outline: "none"
          // Remove default outline to use focus-visible styles
        },
        "&:focus-visible, a&:focus-visible": {
          outline: "2px solid var(--borders-brand-teal-primary)",
          outlineOffset: "2px",
          borderRadius: "0.375rem",
          boxShadow: "none",
          // Remove shadow on focus-visible
          textDecoration: "none"
        },
        "&:active, a&:active": {
          border: "1px solid transparent",
          boxShadow: "none",
          // Remove shadow on active
          textDecoration: "none"
        },
        '&.Mui-disabled, &[aria-disabled="true"]': {
          cursor: "not-allowed",
          boxShadow: "none"
          // Remove shadow when disabled
        },
        // Disable ripple effect (CSS fallback in case defaultProps doesn't work)
        "& .MuiTouchRipple-root": {
          display: "none"
        },
        // Force hover state
        '&.force-hover, &[data-force-hover="true"]': {
          boxShadow: "none",
          textDecoration: "none"
        },
        // Remove margins from startIcon and endIcon - use gap instead (matching genericButton.module.scss)
        "& .MuiButton-startIcon": {
          marginLeft: 0,
          marginRight: 0
        },
        "& .MuiButton-endIcon": {
          marginLeft: 0,
          marginRight: 0
        },
        // Pending state with hidden text - center the spinner
        "&.buttonPendingWithHiddenText": {
          position: "relative"
        },
        "&.buttonPendingWithHiddenText .MuiButton-startIcon": {
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          margin: 0
        }
      };
      return baseStyles;
    },
    // Color styling is now handled via variants above
    // These are intentional placeholders. In MUI, styleOverrides.variantName can override variant styles,
    // but since all variant × color styling is handled in the variants array, these are
    // kept empty to prevent MUI from applying default variant styles that would conflict with our custom styling.
    contained: () => ({}),
    outlined: () => ({}),
    text: () => ({})
  }
};

// src/themes/code.org/styleOverrides/iconButton.tsx
var ICON_BUTTON_SIZE_SPECS = {
  xs: {
    padding: "0.25rem",
    minWidth: "1.5rem",
    minHeight: "1.5rem",
    iconSize: "0.8125rem",
    iconWidth: "1rem"
  },
  s: {
    padding: "0.4375rem",
    minWidth: "2rem",
    minHeight: "2rem",
    iconSize: "0.875rem",
    iconWidth: "1.125rem"
  },
  m: {
    padding: "0.625rem",
    minWidth: "2.5rem",
    minHeight: "2.5rem",
    iconSize: "1rem",
    iconWidth: "1.25rem"
  },
  l: {
    padding: "0.75rem",
    minWidth: "3rem",
    minHeight: "3rem",
    iconSize: "1.1875rem",
    iconWidth: "1.5rem"
  }
};
var iconButtonVariants = [
  // Size variants - matching genericButton.module.scss icon-only styles
  {
    props: { size: "extraSmall" },
    style: {
      padding: ICON_BUTTON_SIZE_SPECS.xs.padding,
      minWidth: ICON_BUTTON_SIZE_SPECS.xs.minWidth,
      minHeight: ICON_BUTTON_SIZE_SPECS.xs.minHeight,
      "& svg, & i": {
        fontSize: ICON_BUTTON_SIZE_SPECS.xs.iconSize,
        // lineHeight: '125%',
        width: ICON_BUTTON_SIZE_SPECS.xs.iconWidth
      }
    }
  },
  {
    props: { size: "small" },
    style: {
      padding: ICON_BUTTON_SIZE_SPECS.s.padding,
      minWidth: ICON_BUTTON_SIZE_SPECS.s.minWidth,
      minHeight: ICON_BUTTON_SIZE_SPECS.s.minHeight,
      "& svg, & i": {
        fontSize: ICON_BUTTON_SIZE_SPECS.s.iconSize,
        lineHeight: "125%",
        width: ICON_BUTTON_SIZE_SPECS.s.iconWidth
      }
    }
  },
  {
    props: { size: "medium" },
    style: {
      padding: ICON_BUTTON_SIZE_SPECS.m.padding,
      minWidth: ICON_BUTTON_SIZE_SPECS.m.minWidth,
      minHeight: ICON_BUTTON_SIZE_SPECS.m.minHeight,
      "& svg, & i": {
        fontSize: ICON_BUTTON_SIZE_SPECS.m.iconSize,
        lineHeight: "125%",
        width: ICON_BUTTON_SIZE_SPECS.m.iconWidth
      }
    }
  },
  {
    props: { size: "large" },
    style: {
      padding: ICON_BUTTON_SIZE_SPECS.l.padding,
      minWidth: ICON_BUTTON_SIZE_SPECS.l.minWidth,
      minHeight: ICON_BUTTON_SIZE_SPECS.l.minHeight,
      "& svg, & i": {
        fontSize: ICON_BUTTON_SIZE_SPECS.l.iconSize,
        lineHeight: "125%",
        width: ICON_BUTTON_SIZE_SPECS.l.iconWidth
      }
    }
  },
  // Contained variant × color combinations
  {
    props: { variant: "contained", color: "primary" },
    style: {
      backgroundColor: "var(--background-brand-purple-primary)",
      color: "var(--text-neutral-white-fixed)",
      '&:hover, &.force-hover, &[data-force-hover="true"]': {
        backgroundColor: "var(--background-brand-purple-strong)",
        color: "var(--text-neutral-white-fixed)"
      },
      "&:focus, a&:focus": {
        color: "var(--text-neutral-white-fixed)"
      },
      "&:active, a&:active": {
        color: "var(--text-neutral-white-fixed)"
      },
      "&.Mui-disabled": {
        backgroundColor: "var(--background-neutral-disabled)",
        color: "var(--text-neutral-disabled-inverse)"
      }
    }
  },
  {
    props: { variant: "contained", color: "secondary" },
    style: {
      backgroundColor: "var(--background-neutral-primary-inverse)",
      color: "var(--text-neutral-inverse)",
      '&:hover, &.force-hover, &[data-force-hover="true"]': {
        backgroundColor: "var(--background-neutral-octonary)",
        color: "var(--text-neutral-inverse)"
      },
      "&:focus, a&:focus": {
        color: "var(--text-neutral-inverse)"
      },
      "&:active, a&:active": {
        color: "var(--text-neutral-inverse)"
      },
      "&.Mui-disabled": {
        backgroundColor: "var(--background-neutral-disabled)",
        color: "var(--text-neutral-disabled-inverse)"
      }
    }
  },
  {
    props: { variant: "contained", color: "white" },
    style: {
      backgroundColor: "var(--background-neutral-white-fixed)",
      color: "var(--text-neutral-primary)",
      '&:hover, &.force-hover, &[data-force-hover="true"]': {
        backgroundColor: "var(--background-neutral-quaternary)",
        color: "var(--text-neutral-primary)"
      },
      "&:focus, a&:focus": {
        color: "var(--text-neutral-primary)"
      },
      "&:active, a&:active": {
        color: "var(--text-neutral-primary)"
      },
      "&.Mui-disabled": {
        backgroundColor: "var(--background-neutral-octonary)",
        color: "var(--text-neutral-primary)"
      }
    }
  },
  {
    props: { variant: "contained", color: "error" },
    style: {
      backgroundColor: "var(--background-error-primary)",
      color: "var(--text-neutral-white-fixed)",
      '&:hover, &.force-hover, &[data-force-hover="true"]': {
        backgroundColor: "var(--background-error-strong)",
        color: "var(--text-neutral-white-fixed)"
      },
      "&:focus, a&:focus": {
        color: "var(--text-neutral-white-fixed)"
      },
      "&:active, a&:active": {
        color: "var(--text-neutral-white-fixed)"
      },
      "&.Mui-disabled": {
        backgroundColor: "var(--background-neutral-disabled)",
        color: "var(--text-neutral-disabled-inverse)"
      }
    }
  },
  // Outlined variant × color combinations
  {
    props: { variant: "outlined", color: "primary" },
    style: {
      border: "1px solid var(--borders-brand-purple-primary)",
      backgroundColor: "transparent",
      color: "var(--text-brand-purple-primary)",
      '&:hover, &.force-hover, &[data-force-hover="true"]': {
        backgroundColor: "var(--background-brand-purple-hover)",
        border: "1px solid var(--borders-brand-purple-primary)",
        color: "var(--text-brand-purple-primary)"
      },
      "&:focus, a&:focus": {
        color: "var(--text-brand-purple-primary)"
      },
      "&:active, a&:active": {
        border: "1px solid var(--borders-brand-purple-primary)",
        color: "var(--text-brand-purple-primary)"
      },
      "&.Mui-disabled": {
        borderColor: "var(--borders-neutral-disabled) !important",
        color: "var(--text-neutral-disabled)",
        backgroundColor: "var(--background-neutral-primary)"
      }
    }
  },
  {
    props: { variant: "outlined", color: "secondary" },
    style: {
      border: "1px solid var(--borders-neutral-solid)",
      backgroundColor: "var(--background-neutral-primary)",
      color: "var(--text-neutral-primary)",
      '&:hover, &.force-hover, &[data-force-hover="true"]': {
        backgroundColor: "var(--background-neutral-tertiary)",
        border: "1px solid var(--borders-neutral-solid)",
        color: "var(--text-neutral-primary)"
      },
      "&:focus, a&:focus": {
        color: "var(--text-neutral-primary)"
      },
      "&:active, a&:active": {
        border: "1px solid var(--borders-neutral-solid)",
        color: "var(--text-neutral-primary)"
      },
      "&.Mui-disabled": {
        borderColor: "var(--borders-neutral-disabled)",
        color: "var(--text-neutral-disabled)",
        backgroundColor: "var(--background-neutral-primary)"
      }
    }
  },
  {
    props: { variant: "outlined", color: "tertiary" },
    style: {
      border: "1px solid var(--borders-neutral-strong)",
      backgroundColor: "var(--background-neutral-primary)",
      color: "var(--text-neutral-primary)",
      '&:hover, &.force-hover, &[data-force-hover="true"]': {
        backgroundColor: "var(--background-neutral-tertiary)",
        border: "1px solid var(--borders-neutral-strong)",
        color: "var(--text-neutral-primary)"
      },
      "&:focus, a&:focus": {
        color: "var(--text-neutral-primary)"
      },
      "&:active, a&:active": {
        border: "1px solid var(--borders-neutral-strong)",
        color: "var(--text-neutral-primary)"
      },
      "&.Mui-disabled": {
        borderColor: "var(--borders-neutral-disabled)",
        color: "var(--text-neutral-disabled)",
        backgroundColor: "var(--background-neutral-primary)"
      }
    }
  },
  {
    props: { variant: "outlined", color: "white" },
    style: {
      border: "1px solid var(--neutral-base-white)",
      backgroundColor: "var(--neutral-base-black)",
      color: "var(--neutral-base-white)",
      '&:hover, &.force-hover, &[data-force-hover="true"]': {
        backgroundColor: "var(--neutral-gray-80)",
        border: "1px solid var(--neutral-base-white)",
        color: "var(--neutral-base-white)"
      },
      "&:focus, a&:focus": {
        color: "var(--neutral-base-white)"
      },
      "&:active, a&:active": {
        border: "1px solid var(--neutral-base-white)",
        color: "var(--neutral-base-white)"
        // Override global link styles via specificity
      },
      "&.Mui-disabled": {
        borderColor: "var(--neutral-gray-80)",
        color: "var(--neutral-gray-80)",
        backgroundColor: "unset"
      }
    }
  },
  {
    props: { variant: "outlined", color: "error" },
    style: {
      border: "1px solid var(--borders-error-primary)",
      backgroundColor: "var(--background-neutral-primary)",
      color: "var(--text-error-primary)",
      '&:hover, &.force-hover, &[data-force-hover="true"]': {
        backgroundColor: "var(--background-error-light)",
        border: "1px solid var(--borders-error-primary)",
        color: "var(--text-error-primary)"
      },
      "&:focus, a&:focus": {
        color: "var(--text-error-primary)"
      },
      "&:active, a&:active": {
        border: "1px solid var(--borders-error-primary)",
        color: "var(--text-error-primary)"
      },
      "&.Mui-disabled": {
        borderColor: "var(--borders-neutral-disabled)",
        color: "var(--text-neutral-disabled)",
        backgroundColor: "var(--background-neutral-primary)"
      }
    }
  },
  // Text variant × color combinations
  {
    props: { variant: "text", color: "primary" },
    style: {
      backgroundColor: "transparent",
      color: "var(--text-brand-purple-primary)",
      '&:hover, &.force-hover, &[data-force-hover="true"]': {
        backgroundColor: "var(--background-brand-purple-hover)",
        color: "var(--text-brand-purple-primary)"
      },
      "&:focus, a&:focus": {
        color: "var(--text-brand-purple-primary)"
      },
      "&:active, a&:active": {
        backgroundColor: "var(--background-brand-purple-hover)",
        color: "var(--text-brand-purple-secondary)"
      },
      "&.Mui-disabled": {
        color: "var(--text-neutral-disabled)",
        backgroundColor: "transparent"
      }
    }
  },
  {
    props: { variant: "text", color: "secondary" },
    style: {
      backgroundColor: "transparent",
      color: "var(--text-neutral-primary)",
      '&:hover, &.force-hover, &[data-force-hover="true"]': {
        backgroundColor: "var(--background-neutral-quaternary)",
        color: "var(--text-neutral-primary)"
      },
      "&:focus, a&:focus": {
        color: "var(--text-neutral-primary)"
      },
      "&:active, a&:active": {
        backgroundColor: "var(--background-neutral-quaternary)",
        color: "var(--text-neutral-tertiary)"
      },
      "&.Mui-disabled": {
        color: "var(--text-neutral-disabled)",
        backgroundColor: "transparent"
      }
    }
  },
  {
    props: { variant: "text", color: "tertiary" },
    style: {
      backgroundColor: "transparent",
      color: "var(--text-neutral-quaternary)",
      '&:hover, &.force-hover, &[data-force-hover="true"]': {
        backgroundColor: "var(--background-neutral-quaternary)",
        color: "var(--text-neutral-quaternary)"
      },
      "&:focus, a&:focus": {
        color: "var(--text-neutral-quaternary)"
      },
      "&:active, a&:active": {
        backgroundColor: "var(--background-neutral-quaternary)",
        color: "var(--text-neutral-tertiary)"
      },
      "&.Mui-disabled": {
        color: "var(--text-neutral-disabled)",
        backgroundColor: "transparent"
      }
    }
  },
  {
    props: { variant: "text", color: "white" },
    style: {
      backgroundColor: "transparent",
      color: "var(--neutral-base-white)",
      '&:hover, &.force-hover, &[data-force-hover="true"]': {
        backgroundColor: "var(--neutral-white-alpha-30)",
        color: "var(--neutral-base-white)"
      },
      "&:focus, a&:focus": {
        color: "var(--text-neutral-inverse)"
      },
      "&:active, a&:active": {
        backgroundColor: "var(--neutral-white-alpha-30)",
        color: "var(--neutral-gray-20)"
      },
      "&.Mui-disabled": {
        color: "var(--text-neutral-tertiary)",
        backgroundColor: "transparent"
      }
    }
  },
  {
    props: { variant: "text", color: "error" },
    style: {
      backgroundColor: "transparent",
      color: "var(--text-error-primary)",
      '&:hover, &.force-hover, &[data-force-hover="true"]': {
        backgroundColor: "var(--background-error-light)",
        color: "var(--text-error-primary)"
      },
      "&:focus, a&:focus": {
        color: "var(--text-error-primary)"
      },
      "&:active, a&:active": {
        backgroundColor: "var(--background-error-light)",
        color: "var(--text-error-secondary)"
      },
      "&.Mui-disabled": {
        color: "var(--text-neutral-disabled)",
        backgroundColor: "transparent"
      }
    }
  }
];
var ICON_BUTTON_OVERRIDES = {
  variants: iconButtonVariants,
  styleOverrides: {
    root: () => {
      return {
        borderRadius: "0.25rem",
        // Force square corners (MUI defaults to circular)
        transition: "all 0.2s ease-in-out",
        boxShadow: "none",
        // Remove MUI's default shadow
        minWidth: "auto",
        // Remove MUI's default minWidth
        padding: "0",
        // Padding is handled by size variants
        textDecoration: "none",
        // Override global link styles when iconButton is rendered as <a>
        "&:hover, a&:hover": {
          boxShadow: "none",
          // Remove shadow on hover
          textDecoration: "none"
        },
        "&:focus, a&:focus": {
          boxShadow: "none",
          // Remove shadow on focus
          textDecoration: "none",
          outline: "none"
        },
        "&:focus-visible, a&:focus-visible": {
          outline: "2px solid var(--borders-brand-teal-primary)",
          outlineOffset: "2px",
          borderRadius: "0.375rem",
          boxShadow: "none",
          // Remove shadow on focus-visible
          textDecoration: "none"
        },
        "&:active, a&:active": {
          boxShadow: "none",
          // Remove shadow on active
          textDecoration: "none"
        },
        "&.Mui-disabled": {
          cursor: "not-allowed",
          boxShadow: "none"
          // Remove shadow when disabled
        },
        // Force hover state (still supports data attribute for backwards compatibility)
        '&.force-hover, &[data-force-hover="true"]': {
          boxShadow: "none",
          textDecoration: "none"
        },
        // Disable ripple effect (CSS fallback in case defaultProps doesn't work)
        "& .MuiTouchRipple-root": {
          display: "none"
        }
      };
    }
  }
};

// src/themes/code.org/styleOverrides/link.ts
var LINK_OVERRIDES = {
  defaultProps: {
    variant: "body2"
  },
  styleOverrides: {
    root: ({ theme: theme2 }) => ({
      fontWeight: theme2.typography.fontWeightBold
    })
  }
};

// src/themes/code.org/styleOverrides/typography.ts
var TYPOGRAPHY_OVERRIDES = {
  defaultProps: {
    variantMapping: {
      body3: "p",
      body4: "p",
      overline1: "p",
      overline2: "p",
      overline3: "p",
      figcaption: "figcaption",
      label1: "span",
      label2: "span",
      label3: "span",
      label4: "span",
      em: "em",
      strong: "strong"
    }
  },
  styleOverrides: {
    root: () => ({
      color: "var(--text-neutral-primary)",
      // when Typography is used as a wrapper (component="div")
      "&:where(div)": {
        "& :is(p, ul, ol, li, h1, h2, h3, h4, h5, h6, span)": {
          font: "inherit",
          fontSize: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
          color: "inherit"
        }
      }
    }),
    gutterBottom: ({ theme: theme2 }) => ({
      "&:where(.MuiTypography-h1)": {
        marginBottom: theme2.spacing(3)
        // 24px
      },
      "&:where(.MuiTypography-h2)": {
        marginBottom: theme2.spacing(2.125)
        // 17px
      },
      "&:where(.MuiTypography-h3)": {
        marginBottom: theme2.spacing(1.75)
        // 14px
      },
      "&:where(.MuiTypography-h4)": {
        marginBottom: theme2.spacing(1.5)
        // 12px
      },
      "&:where(.MuiTypography-h5)": {
        marginBottom: theme2.spacing(1.25)
        // 10px
      },
      "&:where(.MuiTypography-h6)": {
        marginBottom: theme2.spacing(1)
        // 8px
      },
      "&:where(.MuiTypography-body1)": {
        marginBottom: theme2.spacing(2.5)
        // 20px
      },
      "&:where(.MuiTypography-body2)": {
        marginBottom: theme2.spacing(2)
        // 16px
      },
      "&:where(.MuiTypography-body3)": {
        marginBottom: theme2.spacing(1.75)
        // 14px
      },
      "&:where(.MuiTypography-body4)": {
        marginBottom: theme2.spacing(1.625)
        // 13px
      },
      "&:where(.MuiTypography-overline1)": {
        marginBottom: theme2.spacing(1.75)
        // 14px
      },
      "&:where(.MuiTypography-overline2)": {
        marginBottom: theme2.spacing(1.625)
        // 13px
      },
      "&:where(.MuiTypography-overline3)": {
        marginBottom: theme2.spacing(1.375)
        // 11px
      },
      "&:where(.MuiTypography-figcaption)": {
        marginBottom: theme2.spacing(1.75)
        // 14px
      }
    })
  }
};

// src/themes/code.org/styleOverrides/index.ts
var BUTTON_BASE_OVERRIDES = {
  defaultProps: {
    disableRipple: true
  }
};
var STYLE_OVERRIDES = {
  MuiTypography: TYPOGRAPHY_OVERRIDES,
  MuiLink: LINK_OVERRIDES,
  MuiBreadcrumbs: BREADCRUMBS_OVERRIDES,
  MuiButtonBase: BUTTON_BASE_OVERRIDES,
  MuiButton: BUTTON_OVERRIDES,
  MuiIconButton: ICON_BUTTON_OVERRIDES
};

// src/themes/code.org/index.ts
var theme = (0, import_material.createTheme)({
  cssVariables: true,
  components: STYLE_OVERRIDES,
  typography: {
    fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
    h1: {
      fontFamily: createFontStack(BARLOW_FONT, NOTO_FONT),
      fontSize: "3rem",
      // 48px
      fontWeight: 600,
      lineHeight: 1.16
    },
    h2: {
      fontFamily: createFontStack(BARLOW_FONT, NOTO_FONT),
      fontSize: "2.125rem",
      // 34px
      fontWeight: 600,
      lineHeight: 1.24
    },
    h3: {
      fontFamily: createFontStack(BARLOW_FONT, NOTO_FONT),
      fontSize: "1.75rem",
      // 28px
      fontWeight: 600,
      lineHeight: 1.28
    },
    h4: {
      fontFamily: createFontStack(BARLOW_FONT, NOTO_FONT),
      fontSize: "1.5rem",
      // 24px
      fontWeight: 600,
      lineHeight: 1.32
    },
    h5: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "1.25rem",
      // 20px
      fontWeight: 600,
      lineHeight: 1.4
    },
    h6: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "1rem",
      // 16px
      fontWeight: 600,
      lineHeight: 1.48
    },
    body1: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "1.25rem",
      // 20px
      fontWeight: 400,
      lineHeight: 1.4
    },
    body2: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "1rem",
      // 16px
      fontWeight: 400,
      lineHeight: 1.48
    },
    body3: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.54
    },
    body4: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.813rem",
      fontWeight: 400,
      lineHeight: 1.64
    },
    overline1: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.875rem",
      // 14px
      fontWeight: 600,
      letterSpacing: "0.04rem",
      // 0.64px
      lineHeight: 1.54,
      textTransform: "uppercase"
    },
    overline2: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.813rem",
      // 13px
      fontWeight: 600,
      letterSpacing: "0.04rem",
      // 0.64px
      lineHeight: 1.64,
      textTransform: "uppercase"
    },
    overline3: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.688rem",
      // 11px
      fontWeight: 600,
      letterSpacing: "0.04rem",
      // 0.64px
      lineHeight: 1.76,
      textTransform: "uppercase"
    },
    figcaption: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.875rem",
      // 14px
      fontWeight: 600,
      lineHeight: 1.54,
      marginTop: "0.438rem"
      // 7px
    },
    strong: {
      fontWeight: 600
    },
    em: {
      fontStyle: "italic"
    },
    // Label typography variants for form labels and breadcrumbs
    label1: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "1rem",
      // 16px
      fontWeight: 600,
      lineHeight: 1.48
    },
    label2: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.875rem",
      // 14px
      fontWeight: 600,
      lineHeight: 1.54
    },
    label3: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.75rem",
      // 12px
      fontWeight: 600,
      lineHeight: 1.64
    },
    label4: {
      fontFamily: createFontStack(FIGTREE_FONT, NOTO_FONT),
      fontSize: "0.625rem",
      // 10px
      fontWeight: 600,
      lineHeight: 1.8
    }
  }
});
var code_default = theme;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CdoTheme
});
//# sourceMappingURL=index.js.map